/**
     * Encoding function for a firebase key
     */
var encode = (function() {
  var encode = encodeURIComponent;
  var replacements = {
    ".": { re: "\\.", val: "%2E" },
    $: { re: "$", val: encode("$") },
    "[": { re: "\\[", val: encode("[") },
    "]": { re: "\\]", val: encode("]") },
    "#": { re: "#", val: encode("#") },
    "/": { re: "/", val: encode("/") }
  };
  var replaceables = new RegExp(
    "[" +
      Object.keys(replacements)
        .map(function(k) {
          return replacements[k].re;
        })
        .join("") +
      "]",
    "g"
  );
  var doReplace = function(match) {
    return replacements[match].val;
  };

  return function(userId) {
    if (typeof userId !== "string") {
      return userId;
    }

    return userId.replace(replaceables, doReplace);
  };
})();

/**
     * Decoding function for a firebase key
     */
var decode = (function() {
  var replacements = {
    "%24": { re: "%24", val: "$" },
    "%5B": { re: "%5B", val: "[" },
    "%5D": { re: "%5D", val: "]" },
    "%23": { re: "%23", val: "#" },
    "%2F": { re: "%2F", val: "/" },
    "%2E": { re: "%2E", val: "." }
  };

  var replaceables = new RegExp(
    Object.keys(replacements)
      .map(function(l) {
        return replacements[l].re;
      })
      .join("|"),
    "g"
  );

  var doReplace = function(match) {
    return replacements[match].val;
  };

  return function(val) {
    var t = typeof val;
    if (t == "undefined" || val === null) {
      return val;
    }

    if (t == "string" || (t == "object" && val instanceof String)) {
      return val.replace(replaceables, doReplace);
    }

    if (
      t == "boolean" ||
      t == "number" ||
      (t == "object" &&
        (val instanceof Boolean ||
          val instanceof Number ||
          val instanceof Array))
    ) {
      return val;
    }

    return Object.keys(val)
      .map(function(key) {
        var ret = {
          key: decode(key),
          value: val[key]
        };

        if (typeof ret.value == "object") {
          ret.value = decode(ret.value);
        }
        return ret;
      })
      .reduce(function(acc, curr) {
        acc[curr.key] = curr.value;
        return acc;
      }, {});
  };
})();

export { encode, decode };
